import React from "react"
import styled from "styled-components"
import Link from "next/link"

import Spacer from "~/components/Spacer"
import { cut, buildSlug } from "~/utilities/string"
import { CATEGORIES_URL } from "~/components/faq/constants"
import DesktopContainer from "~/components/DesktopContainer"

import articles from "./articles"

const Section = styled.div`
  background-color: #f7f7f7;
`

const Container = styled.div`
  padding: 4em 4em 6em 4em;
  ${props => props.theme.media.mobile`
    padding: 2em 1em 1em 1em;
  `};
  h4 {
    text-align: center;
    font-size: 2em;
    margin: 0 0 1em 0;
    ${props => props.theme.media.mobile`
      font-size: 1.8em;
    `};
  }
`

const List = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  ${props => props.theme.media.mobile`
    flex-direction: column;
    align-items: center;
  `};
  width: 100%;
  a {
    ${props => props.theme.media.mobile`
      margin: 0 1em 2em 1em;
    `};
    text-decoration: none;
    max-width: 150px;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    h5 {
      margin: 0 0 15px 0;
      font-size: 0.9em;
      &:hover {
        text-decoration: underline;
      }
    }
    margin: 0 1em 0 1em;
    img {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100px;
      width: 150px;
    }
    span {
      margin: 5px 0 0 0;
      color: ${props => props.theme.colors.text.label};
      text-decoration: none;
      font-size: 0.813em;
    }
  }
`

const Grow = styled.div`
  flex: 1;
`

const SugguestedArticles = ({ titles }) => {
  if (!titles || !titles.length) return null
  const foundArticles = articles.filter(i => titles.includes(i.title))
  if (!foundArticles || !foundArticles.length) return null
  return (
    <>
      <Grow />
      <Section>
        <DesktopContainer>
          <Container>
            <h4>Suggested Articles</h4>
            <List>
              {foundArticles.map(article => {
                const categorySlug = CATEGORIES_URL[article.type[0]]
                const slug = buildSlug(article.title)
                const linkHref = "/knowledge-base/[category]/[...slug]"
                const linkAs = `/knowledge-base/${categorySlug}/article/${slug}`
                return (
                  <Link
                    key={article.title}
                    href={linkHref}
                    as={linkAs}
                    passHref
                  >
                    <a>
                      <h5>{article.title}</h5>
                      <span>{cut(article.content, 120, "...")}</span>
                    </a>
                  </Link>
                )
              })}
            </List>
          </Container>
        </DesktopContainer>
        <Spacer mobile={10} desktop={10} />
      </Section>
    </>
  )
}

export default SugguestedArticles
